import { api } from "./api-lib/api";
import { request } from "./helper.actions";

export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNIN_FAILURE = "SIGNIN_FAILURE";
export const TOKEN_EMAIL_TO_STORE = "TOKEN_EMAIL_TO_STORE";

const signInSuccess = resp => ({
  type: SIGNIN_SUCCESS,
  resp
});

const signInFailure = error => ({
  type: SIGNIN_FAILURE,
  error
});

export const getUserData = () => ({
  type: TOKEN_EMAIL_TO_STORE
});

export const signIn = payload => dispatch => {
  dispatch(request());
  return Promise.resolve();
  // return api
  //   .post("/signIn", { ...payload })
  //   .then(resp => {
  //     dispatch(signInSuccess(resp));
  //     localStorage.setItem("token", resp.data.token);
  //     localStorage.setItem("userName", resp.data.user);
  //     localStorage.setItem("userId", 388);
  //     dispatch(getUserData());
  //     return Promise.resolve(resp);
  //   })
  //   .catch(error => {
  //     dispatch(signInFailure(error));
  //     return Promise.reject(error);
  //   });
};

export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const LOGOUT_USER_FAILURE = "LOGOUT_USER_FAILURE";

export const logoutUserSuccess = () => ({
  type: LOGOUT_USER_SUCCESS
});

export const logoutUserFailure = () => ({
  type: LOGOUT_USER_FAILURE
});

export const logoutUser = payload => dispatch => {
  dispatch(request());
  dispatch(logoutUserSuccess({}));
  localStorage.clear();
  return Promise.resolve({ data: { message: 'Signed out successfully.' } });
  // return api
  //   .delete(`/user/${payload}`)
  //   .then(resp => {
  //     dispatch(logoutUserSuccess(resp));
  //     localStorage.setItem("token", resp.data.token);
  //     localStorage.setItem("userName", resp.data.user);
  //     dispatch(getUserData());
  //     return Promise.resolve(resp);
  //   })
  //   .catch(error => {
  //     dispatch(logoutUserSuccess(error));
  //     return Promise.reject(error);
  //   });
};

export const AUTHORIZE_USER_SUCCESS = "AUTHORIZE_USER_SUCCESS";
export const AUTHORIZE_USER_FAILURE = "AUTHORIZE_USER_FAILURE";

const getAuthorizedUserSuccess = resp => ({
  type: AUTHORIZE_USER_SUCCESS,
  resp
});

const getAuthorizedUserFailure = error => ({
  type: AUTHORIZE_USER_FAILURE,
  error
});

export const getAuthorizedUser = (userId, sessionId) => dispatch => {
  dispatch(request());
  localStorage.clear();
  return api
    .get(`/financial_institutions/users/authorized_user?id=${userId}&session_id=${sessionId}`)
    .then(resp => {
      localStorage.setItem("token", resp.data.authentication_token);
      localStorage.setItem("userName", resp.data.name);
      localStorage.setItem("userEmail", resp.data.email);
      localStorage.setItem("userId", userId);
      dispatch(getAuthorizedUserSuccess(resp));
      dispatch(getUserData());
      return Promise.resolve(resp);
    })
    .catch(error => {
      dispatch(getAuthorizedUserFailure(error));
      return Promise.reject(error);
    });
};